import React from 'react';
import { EditableColumnType } from 'components/CustomTable/CustomTable';
import AdditionalInformation from 'components/AdditionalInformation/AdditionalInformation';
import { DataType } from 'store/ducks/DataEntry/Branch/types';
import CustomSelect from 'components/CustomSelect';
import { DatePicker, Input } from 'antd';
import dayjs from 'dayjs';
import { ICurrencyAndCosts } from 'store/ducks/DataEntry/ThirdPartyProviders/types';
import * as Styled from '../Tables/DataEntry/DataEntry.styled';

export const getCurrencyAndCostsColumns = (
  handleSave: (record: ICurrencyAndCosts) => void,
  arrangements: { value: string; label: string }[],
  currencies: { value: string; label: string }[],
  t: any,
): EditableColumnType[] => [
  {
    title: t('CURRENCY_AND_COSTS.ICT_TPP'),
    dataIndex: 'tpp_name',
    editable: false,
    fixed: 'left',
    render: (text: string) => <Input value={text} disabled />,
  },
  {
    title: (
      <Styled.TitleComponent>
        {t('CURRENCY_AND_COSTS.CURRENCY')} <Styled.Asterisx>*</Styled.Asterisx>
        <AdditionalInformation
          color="red"
          description={t('CURRENCY_AND_COSTS.CURRENCY_INFO')}
        />
      </Styled.TitleComponent>
    ),
    dataIndex: 'currency_id',
    editable: false,
    className: 'highlighted-column',
    render: (_, record) => (
      <CustomSelect
        options={currencies}
        value={record.currency_id}
        onChange={(value: any) => {
          const selectedCurrency = currencies.find(
            (currency) => currency.value === value,
          );
          const currencyName = selectedCurrency ? selectedCurrency.label : '';

          handleSave({
            ...record,
            currency_id: value,
            currency_name: currencyName,
            // currency_description: currencyName,
          } as ICurrencyAndCosts);
        }}
        filterOption={(input: string, option: { label: string }) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
      />
    ),
  },
  {
    title: (
      <strong>
        <Styled.TitleComponent>
          {t('CURRENCY_AND_COSTS.TOTAL_ANNUAL_EXPENSE')}
          <Styled.Asterisx>*</Styled.Asterisx>
          <AdditionalInformation
            color="red"
            description={t('CURRENCY_AND_COSTS.TOTAL_ANNUAL_EXPENSE_INFO')}
          />
        </Styled.TitleComponent>
      </strong>
    ),
    dataIndex: 'total_annual_expense',
    editable: true,
    type: 'cost',
    className: 'highlighted-column',
  },
  {
    title: (
      <>
        {t('CURRENCY_AND_COSTS.CURRENCY_VALIDATION_FROM_TO')}

        <Styled.Asterisx>*</Styled.Asterisx>
      </>
    ),
    dataIndex: 'date_range',
    editable: false,
    render: (_: any, record: DataType) => {
      const entityRecord = record as ICurrencyAndCosts;

      return (
        <Styled.DateInputs>
          <DatePicker
            format="YYYY-MM-DD"
            value={
              entityRecord.start_date ? dayjs(entityRecord.start_date) : null
            }
            onClick={(e) => e.stopPropagation()}
            onChange={(date) => {
              const formattedDateString = date
                ? dayjs(date).format('YYYY-MM-DD')
                : '';

              const updatedRow: ICurrencyAndCosts = {
                ...entityRecord,
                start_date: formattedDateString,
              };

              handleSave(updatedRow);
            }}
          />

          <DatePicker
            format="YYYY-MM-DD"
            value={
              entityRecord.end_date
                ? dayjs(entityRecord.end_date)
                : dayjs('9999-01-01')
            }
            onClick={(e) => e.stopPropagation()}
            onChange={(date) => {
              const formattedDateString = date
                ? dayjs(date).format('YYYY-MM-DD')
                : '9999-01-01';

              const updatedRow: ICurrencyAndCosts = {
                ...entityRecord,
                end_date: formattedDateString,
              };

              handleSave(updatedRow);
            }}
          />
        </Styled.DateInputs>
      );
    },
  },
];
